import { create } from 'zustand'

interface DraftAnswerState {
    // Map of questId -> draft answer ID
    draftIds: Record<string, string>

    setDraft: (questId: string, answerId: string) => void
    getDraftId: (questId: string) => string | undefined
    clearDraft: (questId: string) => void
    hasDraft: (questId: string) => boolean
}

export const useDraftAnswerStore = create<DraftAnswerState>((set, get) => ({
    draftIds: {},

    setDraft: (questId, answerId) =>
        set(state => ({
            draftIds: { ...state.draftIds, [questId]: answerId },
        })),

    getDraftId: questId => get().draftIds[questId],

    clearDraft: questId =>
        set(state => {
            const { [questId]: _, ...rest } = state.draftIds
            return { draftIds: rest }
        }),

    hasDraft: questId => !!get().draftIds[questId],
}))

// Non-hook access for use in non-React code (cache.ts, class components, etc.)
export const draftAnswerStore = {
    setDraft: (questId: string, answerId: string) =>
        useDraftAnswerStore.getState().setDraft(questId, answerId),
    getDraftId: (questId: string) => useDraftAnswerStore.getState().getDraftId(questId),
    clearDraft: (questId: string) => useDraftAnswerStore.getState().clearDraft(questId),
    hasDraft: (questId: string) => useDraftAnswerStore.getState().hasDraft(questId),
}
